import * as React from "react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@radix-ui/react-collapsible"; // Correct import
import { ChevronDown, LucideIcon } from "lucide-react"; // Assuming you're using lucide-react for icons
import { SidebarGroup } from "./ui/sidebar"; // Make sure SidebarGroup is imported correctly

interface CollapsibleSidebarProps {
  h: string;
  children: React.ReactNode;
  Icon: LucideIcon ;
}

export default function CollapsibleSidebar({
  h,
  Icon,
  children,
}: CollapsibleSidebarProps) {
  return (
    <Collapsible defaultOpen className="group/collapsible overflow-hidden">
      <CollapsibleTrigger className="flex hover:bg-secondary items-center justify-between space-x-4 px-3 my-2 w-full rounded cursor-pointer">
        <span className="flex items-center text-foreground">
          <Icon size={16} />
          <span className="text-lg font-medium ml-2">{h}</span>
        </span>
        <ChevronDown className="ml-auto text-foreground transition-transform group-data-[state=open]/collapsible:rotate-180" />
      </CollapsibleTrigger>

      <CollapsibleContent>
        <SidebarGroup className="ml-3 text-base hover:bg-none h-fit py-0">
          {children}
        </SidebarGroup>
      </CollapsibleContent>
    </Collapsible>
  );
}
